module.exports = __webpack_public_path__ + "static/media/icon-covered.85e1461e.svg";